import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import ElevationImg from './img/ElevationImg.png'

export default class ElevationAnalysis extends Component {
  render() {
    return (
      <div className="main-window">
        <div className="main-window-title">使用高程分析</div>
        <div className="main-window-content">1、点击高程分析</div>
        <div className="main-window-content">2、球上点击所需具体的点位</div>
        <div className="main-window-content">3、出现所选点位的高程分析图</div>
        <img src={ElevationImg} className="main-window-img"></img>
      </div>
    )
  }
}
